import './FaqAccordion.scss';

import classNames from 'classnames';
import { type ReactNode, useState } from 'react';

export type FaqAccordionItem = {
  id: string;
  question: string;
  answer: ReactNode;
};

export type FaqAccordionProps = {
  items: FaqAccordionItem[];
  defaultOpenIds?: string[];
  className?: string;
  idPrefix?: string;
};

export const FaqAccordion = ({
  items,
  defaultOpenIds = [],
  className,
  idPrefix = 'faq-accordion',
}: FaqAccordionProps) => {
  const [openIds, setOpenIds] = useState<string[]>(defaultOpenIds);

  const toggle = (id: string) => {
    setOpenIds(prev => (prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]));
  };

  return (
    <div className={classNames('faq-accordion', className)}>
      {items.map(item => {
        const isOpen = openIds.includes(item.id);
        const answerId = `${idPrefix}-answer-${item.id}`;

        return (
          <div key={item.id} className='faq-accordion__item'>
            <button
              type='button'
              className='faq-accordion__question'
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
              aria-controls={answerId}
            >
              <h3>{item.question}</h3>
              <span className={classNames('faq-accordion__icon', { 'is-open': isOpen })} aria-hidden='true'>
                +
              </span>
            </button>
            <div id={answerId} className={classNames('faq-accordion__answer', { 'is-open': isOpen })}>
              <p>{item.answer}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
